const pageTemplates = [
  {
    id: "blank",
    label: "Página en blanco",
    description: "Comienza desde cero sin secciones predefinidas",
    icon: "pi pi-file",
    sections: [],
  },
  {
    id: "info",
    label: "Página informativa",
    description: "Título + texto con párrafos para contenido largo",
    icon: "pi pi-info-circle",
    sections: [
      { type: "encabezado", title: "Título de la página", subtitle: "Subtítulo descriptivo", description: "Introducción breve." },
      { type: "texto", title: "Contenido", paragraphsText: "Escribe aquí tu contenido principal." },
    ],
  },
  {
    id: "faq",
    label: "Preguntas frecuentes",
    description: "Sección tipo acordeón con preguntas y respuestas",
    icon: "pi pi-question-circle",
    sections: [
      { type: "encabezado", title: "Preguntas frecuentes", subtitle: "Respuestas a las consultas más comunes" },
      { type: "acordeon", title: "", description: "", itemsText: "¿Cómo funciona? | Explicación breve del servicio.\n¿Cuáles son los horarios? | Lunes a viernes de 9 a 18 hrs." },
    ],
  },
  {
    id: "landing",
    label: "Landing page",
    description: "Portada con imagen + beneficios + llamado a la acción",
    icon: "pi pi-pencil",
    sections: [
      { type: "portada", title: "Título impactante", subtitle: "Subtítulo de valor", description: "Descripción corta.", backgroundImage: "" },
      { type: "filasDivididas", title: "Beneficios", itemsText: "Beneficio 1 | Descripción del beneficio\nBeneficio 2 | Descripción del beneficio\nBeneficio 3 | Descripción del beneficio" },
    ],
  },
  {
    id: "timeline",
    label: "Historia o proceso",
    description: "Línea de tiempo para mostrar etapas o hitos",
    icon: "pi pi-clock",
    sections: [
      { type: "encabezado", title: "Nuestra historia", subtitle: "Los hitos que nos definen" },
      { type: "lineaTiempo", title: "", itemsText: "2020 | Fundación | Comenzamos como un pequeño emprendimiento.\n2022 | Crecimiento | Expandimos nuestras operaciones a nivel nacional.\n2024 | Consolidación | Nos posicionamos como líderes del mercado." },
    ],
  },
];

export default pageTemplates;
